import {
  MessageConfig, MessageType, NotificationConfig, NotificationType,
} from '@routific/hive';
import { UNKNOWN_STOP } from './constants';

export const getReschedulingStopMessageKey = (visitId: string): string => `rescheduling-stop-${visitId}`;

export const reschedulingStopMessage = (visitId: string, visitName?: string | null): MessageConfig => ({
  key: getReschedulingStopMessageKey(visitId),
  type: MessageType.LOADING,
  content: `Re-calculating ETA for ${visitName || UNKNOWN_STOP}...`,
  dataCy: 'rescheduling-stop-message',
  duration: 0,
});

export const rescheduleStopFailNotification = (visitId: string, visitName?: string | null, onViewStop?: () => void): NotificationConfig => ({
  id: `reschedule-stop-${visitId}-failure`,
  type: NotificationType.ERROR,
  message: `Couldn't re-calculate ETA for  ${visitName || UNKNOWN_STOP}. Please try again in a few minutes.`,
  linkMessage: onViewStop ? 'View Stop' : undefined,
  linkOnClick: onViewStop,
});

export const rescheduleStopSuccessNotification = (visitId: string, visitName?: string | null, onViewStop?: () => void): NotificationConfig => ({
  id: `reschedule-stop-${visitId}-success`,
  type: NotificationType.SUCCESS,
  message: `Re-calculated ETA for ${visitName || UNKNOWN_STOP}.`,
  dataCy: 're-calculated-eta',
  linkMessage: onViewStop ? 'View Stop' : undefined,
  linkOnClick: onViewStop,
});
